import React, { useState, useEffect } from "react";
import { Row, Col, Button } from "reactstrap";
import { Link } from "react-router-dom";
import { iconList } from '../../utils/iconList'
import useAuth from "../../hooks/useAuth";
import { roleRoutes } from "utils/roles";
import Spinner from "components/spinner/spinner";
import { useTranslation } from "react-i18next";

export default function Error() {
  const { t } = useTranslation();
  const [link, setLink] = useState('/home')
  const { user, isLoading } = useAuth();

  useEffect(() => {
    if(user?.role === roleRoutes.client) setLink('/home')
    if(user?.role === roleRoutes.admin) setLink('/admin')
  }, [user])

  // Solo mientras se resuelve la sesión: con usuario YA resuelto hay que
  // mostrar el 404 (antes `|| user` dejaba a cualquier logueado en un spinner
  // eterno en toda ruta inexistente).
  if(isLoading) return <div className="w-full h-full flex items-center justify-center"><Spinner/></div>
  return (
    <Row>
      <Col xs="12" className="d-flex justify-content-center vh-100 align-items-center">
        <div className="text-center">
          <h4 className="error-message">
            {t("Lo sentimos, pero parece que la página que estás buscando no existe.")}
          </h4>
          <img src={iconList["error404"]} alt="error404" />
          <br />
          <Link to={link}>
            <Button className="error-button">{t("Volver al inicio")}</Button>
          </Link>
        </div>
      </Col>
    </Row>
  );
}
